import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { StatusPill } from "./DashboardLayout";
import { toast } from "sonner";

const STATUSES = ["pending", "confirmed", "shipped", "delivered", "cancelled"];

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);

  const load = () => api.get("/orders").then((r) => setOrders(r.data));
  useEffect(() => { load(); }, []);

  const update = async (order_id, status) => {
    await api.put(`/orders/${order_id}/status`, { status });
    toast.success("Order updated");
    load();
  };

  return (
    <div data-testid="admin-orders" className="space-y-4">
      <div className="overline">All orders</div>
      {orders.length === 0 ? (
        <div className="border border-border bg-white p-8 text-sm text-muted-foreground text-center">
          No orders yet.
        </div>
      ) : (
        <div className="border border-border bg-white divide-y divide-border">
          {orders.map((o) => (
            <div key={o.order_id} className="p-4 grid grid-cols-1 md:grid-cols-12 items-start md:items-center gap-2 md:gap-3">
              <div className="md:col-span-3">
                <div className="font-mono text-xs text-muted-foreground">{o.order_id}</div>
                <div className="text-xs text-muted-foreground mt-1">
                  {new Date(o.created_at).toLocaleString()}
                </div>
              </div>
              <div className="md:col-span-3 text-sm">
                <div>{o.user_email}</div>
                <div className="text-xs text-muted-foreground">{o.user_role}</div>
              </div>
              <div className="md:col-span-3 text-xs">
                {o.items.map((i) => (
                  <div key={i.product_id}>
                    {i.name} × {i.quantity}
                  </div>
                ))}
              </div>
              <div className="md:col-span-1 font-mono text-sm">${o.total.toFixed(2)}</div>
              <div className="md:col-span-2 flex items-center gap-2 md:justify-end flex-wrap">
                <StatusPill status={o.status} />
                <Select value={o.status} onValueChange={(v) => update(o.order_id, v)}>
                  <SelectTrigger className="w-[120px] h-8" data-testid={`order-status-${o.order_id}`}>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    {STATUSES.map((s) => (
                      <SelectItem key={s} value={s}>{s}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
